import React, { useEffect, useState } from 'react'
import i18n from 'simple-react-i18n'
import PropTypes from 'prop-types'
import EntityIndicatorDialog from '../EntityIndicatorDialog'
import { Divider, Grid2 } from '@mui/material'
import IndicatorHeaderDialog from '../IndicatorHeaderDialog'
import IndicatorTable from '../IndicatorTable'
import { shallowEqual, useSelector } from 'react-redux'
import { getYear } from 'utils/DateUtil'
import { P101_1, VP_127, DC_192, VP_126 } from 'rpqs/constants/RpqsConstant'
import { getIndicatorDialogRow, updateIndicatorEntity, updateManyIndicatorEntity } from 'rpqs/utils/RPQSUtils'
import { round } from 'lodash'

const DialogP101_1 = ({
    open = false,
    setOpen = () => {},
    title = '',
}) => {
    const {
        managementEntity,
    } = useSelector(store => ({
        managementEntity: store.CollectivityReducer.managementEntity,
    }), shallowEqual)

    const [entityDialog, setEntityDialog] = useState(managementEntity)
    const [readMode, setReadMode] = useState(true)

    useEffect(() => {
        setEntityDialog(managementEntity)
    }, [managementEntity])

    const year = getYear(entityDialog?.dateEnd)
    const previousYear = year-1
    const currentEntity = entityDialog?.[year]

    const getIndicatorValue = (indicator) => (currentEntity?.[indicator?.code]?.value || 0)

    useEffect(() => {
        if (!readMode) return

        const newIndicator = { ...currentEntity?.[P101_1.code], value: getIndicatorValue(VP_127) !== 0 ? round((1-getIndicatorValue(VP_126)/getIndicatorValue(VP_127)*100), 2) : 0 }
        setEntityDialog(updateIndicatorEntity(entityDialog, year, P101_1.code, newIndicator))
    }, [readMode])

    const formatedIndicators = [
        getIndicatorDialogRow({
            readMode,
            entityDialog,
            codeIndicator: P101_1.code,
            indicatorName: i18n[P101_1.i18n],
            unit: '%',
            onChange: v => setEntityDialog(prev => (updateIndicatorEntity(prev, year, P101_1.code,
                { ...currentEntity?.[P101_1.code], value: parseInt(v) || 0 },
            ))),
        }),
        getIndicatorDialogRow({
            entityDialog,
            codeIndicator: DC_192.code,
            indicatorName: i18n[DC_192.i18n],
            unit: '%',
            onChange: v => setEntityDialog(prev => (updateIndicatorEntity(prev, year, DC_192.code,
                { ...currentEntity?.[DC_192.code], value: parseInt(v) || 0 },
            ))),
        }),
        getIndicatorDialogRow({
            entityDialog,
            codeIndicator: VP_126.code,
            indicatorName: i18n[VP_126.i18n],
            unit: i18n.amount,
            onChange: v => setEntityDialog(prev => (updateManyIndicatorEntity(prev, year, [
                { code: VP_126.code, value: { ...currentEntity?.[VP_126.code], value: parseInt(v) || 0 } },
                { code: P101_1.code, value: { ...currentEntity?.[P101_1.code], value: (readMode && getIndicatorValue(VP_127) !== 0) ? round((1-parseInt(v)/getIndicatorValue(VP_127)*100), 2) : getIndicatorValue(P101_1) } },
            ]))),
        }),
        getIndicatorDialogRow({
            entityDialog,
            codeIndicator: VP_127.code,
            indicatorName: i18n[VP_127.i18n],
            unit: i18n.amount,
            onChange: v => setEntityDialog(prev => (updateManyIndicatorEntity(prev, year, [
                { code: VP_127.code, value: { ...currentEntity?.[VP_127.code], value: parseInt(v) || 0 } },
                { code: P101_1.code, value: { ...currentEntity?.[P101_1.code], value: (readMode && getIndicatorValue(VP_127) !== 0) ? round((1-getIndicatorValue(VP_126)/parseInt(v)*100), 2) : getIndicatorValue(P101_1) } },
            ]))),
        }),
    ]

    const onStatusChange = (status) => {
        setEntityDialog(updateIndicatorEntity(entityDialog, year, P101_1.code, { ...currentEntity?.[P101_1.code], status }))
    }

    return (
        <EntityIndicatorDialog
            open={open}
            setOpen={setOpen}
            title={title}
            hasNote
            entityDialog={entityDialog}
            setEntityDialog={setEntityDialog}
            codeIndicator={P101_1.code}
            readMode={readMode}
            setReadMode={setReadMode}
        >
            <Grid2 container direction={'column'} gap={2}>
                <IndicatorHeaderDialog
                    current={{
                        year,
                        value: managementEntity?.[year]?.[P101_1.code]?.value,
                    }}
                    previous={{
                        year: previousYear,
                        value: managementEntity?.[previousYear]?.[P101_1.code]?.value,
                    }}
                    status={entityDialog?.[year]?.[P101_1.code]?.status}
                    onStatusChange={onStatusChange}
                    unit={'%'}
                />
                <Divider/>
                <IndicatorTable
                    year={year?.toString()}
                    indicators={formatedIndicators}
                />

            </Grid2>
        </EntityIndicatorDialog>
    )
}

DialogP101_1.propTypes = {
    setOpen: PropTypes.func,
    open: PropTypes.bool,
    title: PropTypes.string,
}

export default DialogP101_1